module.exports = __webpack_public_path__ + "static/carbazar-9d3fb49e909def1ecedb11bddf601de8.svg";